const ME_QUERY = 'query me { me { id } }';

/**
 * Run GraphQL `me` query with the given token (e.g. after 2FA verify).
 * Returns the current user id so we can send log_in and session_started with userId.
 */
export async function fetchMeId(apiUrl: string, token: string): Promise<string | undefined> {
  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query: ME_QUERY }),
    });
    const json = await res.json();
    const id = json?.data?.me?.id;
    return typeof id === 'string' ? id : undefined;
  } catch {
    return undefined;
  }
}
